import { useEmitter } from '@/plugins'
import type { Route } from '@/interfaces'
import { GeneralWrapper } from '@/wrappers'
import { ref, onMounted, onUnmounted } from 'vue'

export function useNotInvoiced(items: Route[]) {

    const emitter = useEmitter();
    const wrapper = new GeneralWrapper();

    const intervalId = ref<number>(0);
    const formRoutes = ref<Route[]>(items);

    function getCounters(): void {
        wrapper.getNotInvoiced().then(data => {
            data.forEach((item) => formRoutes.value.find(r => r.name === item.name)!.open = item.amount);
        });
    }

    onMounted(() => {
        getCounters();
        emitter.on("update:counters", () => getCounters());

        intervalId.value = setInterval(() => getCounters(), 30000);
    });

    onUnmounted(() => {
        clearInterval(intervalId.value);
        emitter.off("update:counters");
    });

    return {
        formRoutes
    };
}